<script>
	import PageSection from "../../components/PageSection.svelte";
	import PersonalDetails from "./PersonalDetails.svelte";
	import CruiseDetails from "./CruiseDetails.svelte";
	import ClaimDetails from "./ClaimDetails.svelte";
	import DocumentUpload from "./DocumentUpload.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import Checkbox from "../../components/Checkbox.svelte";
	import FormRow from "../../components/FormRow.svelte";

	import { trackSubmit } from "../../analytics";
	import { pageNumber, model } from "../../stores";
	import { projectSettings } from "../../config";

	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;
	export let nextPageLabel = null;
	export let previousPage = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;
	export let title = null;

	let disabled = true;
	let confirmed = false;

	if ($pageNumber == pageIndex + 1) {
		alert("Your registration has already been submitted.");
		window.location.href = window.basePath;
	} else {
		$pageNumber = pageIndex;
	}

	$model.LastPageVisited = lastVisitedPage;
	document.title = pageTitle;

	const onSubmit = () => {
		trackSubmit(projectSettings.classActionName);
	};
</script>

{#if $pageNumber == pageIndex}
	<PageSection>
		<h1>Confirmation</h1>
		<p>
			Please review the information you have provided and confirm the information is true and correct by clicking
			the checkbox below.
		</p>
		<p>
			If you need to edit any of your answers, please do so by clicking the 'Previous' button at the bottom of the
			page.
		</p>

		<PersonalDetails {disabled}></PersonalDetails>
		<CruiseDetails {disabled}></CruiseDetails>
		<ClaimDetails {disabled}></ClaimDetails>
		<DocumentUpload {disabled}></DocumentUpload>

		<FormRow>
			<div class="col-md-8 col-sm-12">
				<Checkbox
					required="true"
					bind:checked={confirmed}
					label="I confirm that all information provided in this section is true and correct."
					id="confirmation"
				></Checkbox>
			</div>
		</FormRow>

		<div class="form-row">
			<div class="col-md-12 last">
				<NavigationButtons
					{persistUrl}
					{previousPage}
					{nextPage}
					{nextPageLabel}
					{onSubmit}
					pageName={title}
					tealiumTag={true}
				></NavigationButtons>
			</div>
		</div>
	</PageSection>
{/if}
